export default class FotosHelper {
	//no usar directamente, usar this.cdn
	static __cdn;

	static get cdn() {
		if (process.env.MIX_CDN == 'local') {
			return 'local'
		}
		if (process.env.MIX_CDN == 'ix') {
			return 'imgix'
		}
		//return 'pixelcrush'
		return 'cloudimage'
	}

	static get dominio() {
		const cdn = this.cdn;
		switch (cdn) {
			case 'local':
				return 'http://localhost:8000/imagenes/';
				break;
			case 'cloudimage':
				return 'https://img.alqastatic.com';
				break;
			case 'imgix':
				return 'http://img.alquilerargentina.com/';
				break;
			default:
				return 'https://v3.alquilerargentina.com/multimedia/';
				break;
		}
	}

	static markerAA(L) {
		return L.icon({
			iconUrl: this.imgV4("marker-aa_c_30.png"),
			iconSize: [30, 41],
			popupAnchor: [0, -40],
			iconAnchor: [30 / 2, 41],
		});
	}

	static imgV4(filename, tipo = 'general') {
		const cdn = this.cdn;
		if (cdn == 'local') {
			return this.dominio + filename;
		}
		if (cdn == 'cloudimage') {
			return this.dominio + '/_img_/' + filename + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio.slice(0, -1) + filename + filtro;	//Le saco la / al dominio pq ya viene con el filename, si algún día corregimos los filename para q no tengan la barra hay que sacar el slice
		}
	}

	static imgMkt(img) {
		const filename = img[FotosHelper.getResolution()];
		return this.dominio + '/' + filename;
	}

	static getResolution() {
		const witdh = window.innerWidth;
		const ratio = window.devicePixelRatio;
		let cual = 'md';
		if (ratio == 2 && witdh <= 360) {
			cual = 'xxs_2x';
		} else if (ratio == 2 && witdh < 768) {
			cual = 'xs_2x';
		} else if (witdh <= 360) {
			cual = 'xxs';
		} else if (witdh < 768) {
			cual = 'xs';
		} else if (witdh >= 1200) {
			cual = 'lg';
		} else if (witdh >= 992) {
			cual = 'md';
		} else if (witdh >= 768) {
			cual = 'sm';
		}
		return cual;
	}

	static imgParaComentario(filename, tipo = "general") {
		//arreglo para fotos de comentarios en ficha y publicar provisorio
		let auxFileName = filename.slice(0, 13); // 13 es el largo de caracteres para poder comparar
		auxFileName = auxFileName == '/_comentarios_/' || auxFileName == '/_propiedades_/' ? '' : '/_comentarios_/';
		auxFileName += filename;
		//
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + auxFileName + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio.slice(0, -1) + auxFileName + filtro;	//Le saco la / al dominio pq ya viene con el filename, si algún día corregimos los filename para q no tengan la barra hay que sacar el slice
		}
	}

	static imgParaPropiedad(ref, filename, tipo = "general") {
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + '/_propiedades_/' + ref + '/' + filename + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + 'propiedades/' + ref + '/' + filename + filtro;
		}
	}

	static landing(id, filename, tipo = "general") {
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + '/_destinos_/' + id + '/' + filename + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + 'landings/' + id + '/' + filename + filtro;
		}
	}

	static banner(id, tipo = "general") {
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + '/_banners_/' + id + '.jpg' + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + 'banners/' + '/' + id + '.jpg' + filtro;
		}
	}

	static fondos(filename, tipo = "general") {
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + '/' + filename + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + filename + filtro;
		}
	}

	static sorteo(id, microtime, tipo = "general") {
		const cdn = this.cdn;
		const time = microtime ? microtime : '';
		if (cdn == 'cloudimage') {
			return this.dominio + '/' + '_sorteos_/' + id + time + '.jpg' + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + 'sorteos/' + '/' + id + '.jpg' + filtro;
		}
	}

	static prensa(filename, tipo = "general") {
		const cdn = this.cdn;
		if (cdn == 'cloudimage') {
			return this.dominio + '/' + filename + this.filtroCloudImage(tipo);
		}
		else if (cdn == 'imgix') {
			const filtro = this.filtroImgix(tipo);
			return this.dominio + filename + filtro;
		}
	}

	static imgMapa(ref) {
		/* TO DO: traer imagen con cdn 
		return this.dominio + '/_mapas_/' + ref + '_2.png?w=870&h=450&q=70'; */
		return this.dominio + '/_mapas_/' + ref + '.png'
	}

	static filtroCloudImage(tipo) {
		return '?p=' + tipo;
	}

	static filtroImgix(tipo) {
		let filtro = '';
		switch (tipo) {
			case 'galeria_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=220&h=165';
				break;

			case 'galeria_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=300&h=225';
				break;
				

			case 'unidad_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=222&h=125';
				break;

			case 'unidad_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=356&h=200';
				break;

			case 'galeria_lg':
				filtro = '?auto=enhance%2Cformat%2Ccompress&mark64=aHR0cDovL2ltZ3Y0LmFscXVpbGVyYXJnZW50aW5hLmNvbS9sb2dvLWFhLWJsYW5jb18zNzAucG5n&markscale=30';
				break;

			case 'listado_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=320&h=240';
				break;

			case 'listado_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=640&h=480';
				break;

			case 'unidad_seglinea_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=150&h=112';
				break;

			case 'unidad_seglinea_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=300&h=225';
				break;

			case 'portada_lg':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=1920&h=400';
				break;

			case 'portada_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=1200&h=400';
				break;

			case 'portada_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=768&h=600';
				break;

			case 'propietario_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=100&h=100';
				break;

			case 'propietario_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=200&h=200';
				break;

			case 'slider_home_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=424&h=280';
				break;

			case 'slider_home_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=640&h=422';
				break;

			case 'para_mapa':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=230&h=153';
				break;

			case 'general':
				filtro = '?auto=enhance%2Cformat%2Ccompress';
				break;

			case 'landing_portada':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&h=450';
				break;

			case 'landing_banner_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=300&h=250';
				break;

			case 'vip_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=660&h=371';
				break;

			case 'landing_album_1_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=222&h=125';
				break;

			case 'landing_album_1_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=356&h=200';
				break;

			case 'landing_album_2_sm':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=150&h=112';
				break;

			case 'landing_album_2_md':
				filtro = '?auto=enhance%2Cformat%2Ccompress&fit=crop&w=300&h=225';
				break;
			default:
				filtro = '?auto=enhance%2Cformat%2Ccompress';
				break;
		}
		return filtro;
	}
}
